import { RELATION_DEPENDENCY_OF } from '@backstage/catalog-model';
import { EntityRelatedEntitiesGridItem } from './EntityRelatedEntitiesGridItem';
import { EntityTable } from '@backstage/plugin-catalog-react';
import { EntityGridItemProps } from './EntityGridItemProps';

export const HasConsumersGridItem = (props: EntityGridItemProps) => {
  return (
    <EntityRelatedEntitiesGridItem
      {...props}
      relationFilter={{
        type: RELATION_DEPENDENCY_OF,
      }}
      title={props.title ?? 'Is dependency of'}
      orderedBy={['spec.type', 'metadata.name']}
      columns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'component' }),
        EntityTable.columns.createOwnerColumn(),
        EntityTable.columns.createSpecTypeColumn(),
        EntityTable.columns.createSpecLifecycleColumn(),
      ]}
      lgColumns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'component' }),
        EntityTable.columns.createOwnerColumn(),
        EntityTable.columns.createSpecTypeColumn(),
        EntityTable.columns.createSpecLifecycleColumn(),
        EntityTable.columns.createMetadataDescriptionColumn(),
      ]}
    />
  );
};
